import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';

const TermsConditions = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="min-h-screen bg-[#030308]">
      <div className="bg-[#0A0A12] border-b border-white/10">
        <div className="max-w-4xl mx-auto px-6 md:px-12 py-6 flex items-center justify-between">
          <Link to="/">
            <Button variant="ghost" className="text-slate-400 hover:text-indigo-400 hover:bg-transparent p-0">
              <ArrowLeft className="w-4 h-4 mr-2" />
              Back to Home
            </Button>
          </Link>
          <span className="text-sm text-slate-500 font-normal uppercase tracking-wider" style={{ fontFamily: "'Outfit', sans-serif" }}>
            Trademark My LLC
          </span>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-6 md:px-12 py-16">
        <h1 className="text-3xl sm:text-4xl font-bold text-white mb-3" style={{ fontFamily: "'Outfit', sans-serif" }}>
          Terms & Conditions
        </h1>
        <p className="text-sm text-slate-500 mb-12">Last Updated: February 2026</p>

        <div className="space-y-8 text-slate-400 leading-relaxed">
          <section>
            <h2 className="text-xl font-semibold text-white mb-3" style={{ fontFamily: "'Outfit', sans-serif" }}>1. Services Overview</h2>
            <p className="text-sm">
              Trademark My LLC provides trademark registration, copyright registration, company formation, trademark search, and Amazon Brand Registry enrollment services. Our services are subject to these Terms and Conditions.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3" style={{ fontFamily: "'Outfit', sans-serif" }}>2. Service Fees</h2>
            <p className="text-sm">
              Our service fees are as listed on our pricing page. Government filing fees (USPTO, state fees) are separate and paid directly to the respective agencies. All service fees are non-refundable once work has commenced on your application.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3" style={{ fontFamily: "'Outfit', sans-serif" }}>3. Client Responsibilities</h2>
            <p className="text-sm">
              Clients are responsible for providing accurate and complete information for their trademark applications. Delays caused by incomplete or inaccurate information provided by clients are not the responsibility of Trademark My LLC.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3" style={{ fontFamily: "'Outfit', sans-serif" }}>4. No Guarantee of Registration</h2>
            <p className="text-sm">
              While we provide expert guidance and professional filing services, we cannot guarantee the approval of any trademark application. Registration decisions are made solely by the USPTO based on federal trademark law.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3" style={{ fontFamily: "'Outfit', sans-serif" }}>5. Limitation of Liability</h2>
            <p className="text-sm">
              Trademark My LLC liability is limited to the service fees paid. We are not liable for any indirect, incidental, or consequential damages arising from the use of our services.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3" style={{ fontFamily: "'Outfit', sans-serif" }}>6. Intellectual Property</h2>
            <p className="text-sm">
              All content on this website, including text, graphics, logos, and software, is the property of Trademark My LLC and protected by intellectual property laws.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3" style={{ fontFamily: "'Outfit', sans-serif" }}>7. Governing Law</h2>
            <p className="text-sm">
              These Terms and Conditions are governed by and construed in accordance with the laws of the State of California, United States.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3" style={{ fontFamily: "'Outfit', sans-serif" }}>8. Contact</h2>
            <p className="text-sm">
              For questions about these Terms, contact us at info@trademarkmyllc.com or call +1 (800) 123-4567.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsConditions;
